import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
export type AuthFragment = { authChallenge: Types.AuthChallenge, token: { accessToken: string, expiresIn: number, refreshToken: string } | null };

export const AuthFragmentDoc = gql`
    fragment Auth on AuthResponse {
  authChallenge
  token {
    accessToken
    expiresIn
    refreshToken
  }
}
    `;